import { useTranslation } from 'react-i18next';
import { useBuilderContext } from '../../context/BuilderContext';

export function PrivacySection() {
  const { t } = useTranslation();
  const { form, setForm } = useBuilderContext();

  return (
    <div className="builder-section">
      <div className="cfg-section-head">
        <div>
          <h3><i className="fas fa-user-secret" /> {t('admin.builderPrivacyTitle')}</h3>
          <p className="cfg-section-sub">{t('admin.builderPrivacySub')}</p>
        </div>
      </div>
      <div className="cfg-boost-row">
        <div className="cfg-boost-left">
          <span className="cfg-boost-icon"><i className="fas fa-user-secret" style={{ color: 'var(--cp-purple)' }} /></span>
          <div>
            <div className="cfg-boost-title">{t('admin.builderEnableAnonymity')}</div>
            <div className="cfg-boost-desc">{t('admin.builderAnonymityDesc')}</div>
          </div>
        </div>
        <label className="cfg-toggle">
          <input
            type="checkbox"
            checked={form.anonymous}
            onChange={e => setForm(p => ({ ...p, anonymous: e.target.checked }))}
          />
          <span className="cfg-toggle-track" />
        </label>
      </div>
    </div>
  );
}
